import { Button, useTheme } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from '@mui/x-data-grid';
import { TableStatus } from './TableStatus';
import { DetailsDisplaySettings } from './DetailsDisplaySettings';
import { useState } from 'react';
import { DialogCentered } from 'src/components/DialogCentered';

export const TableToolbar = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const theme = useTheme();
  return (
    <GridToolbarContainer
      sx={{
        backgroundColor: theme.palette.background.dark,
        borderRadius: '10px',
        p: 1,
        mb: 1,
      }}
    >
      <GridToolbarColumnsButton />
      <Button
        variant="contained"
        size="small"
        sx={{ height: 40, p: 2, m: 1 }}
        onClick={() => {
          return setDialogOpen((prev) => {
            return !prev;
          });
        }}
      >
        details options
      </Button>
      <DialogCentered
        open={dialogOpen}
        onClose={() => {
          return setDialogOpen(false);
        }}
      >
        <DetailsDisplaySettings />
      </DialogCentered>
      <TableStatus />
    </GridToolbarContainer>
  );
};
